"use strict";
awardLetter.classy.controller({
    name: "AwardLetterController",
    inject: [
        "$scope", "authServiceFactory", "SchoolSubcategoriesModelService", "$modal", "$http", "SchoolModelService",
        "SchoolContactsModelService", "BinFactory", "ApplicationService", "AwardLetterTemplatesModelService"
    ],
    init: function() {
        this.$.versionNo = versionNo;
        this.$.reviewOpen = false;
        this.$.schoolmodel = this.SchoolModelService;
        this.$.schoolinfo = this.SchoolModelService.get()[0];
        this.$.insert = [
            {field: "", title: "Application First Name"},
            {field: "", title: "Application Last Name"},
            {field: "", title: "Family First Name"},
            {field: "", title: "Family Last Name"},
            {field: "Division", title: "Grade"},
            {field: "ActAward", title: "Award"}
        ];
        this.$.awardmessage = "";
        this.$.letters = this.AwardLetterTemplatesModelService.get();
        this.authServiceFactory.getAuth();
        this.redactorWorkaround = "setTimeout(function() { document.getElementById('redactor-toolbar-0').click(); });";
    },
    set: function(recordID) {
        if (recordID === undefined) {
            this.$.item = {};
            this.$.letters.push(this.$.item);
            this.$.item.type = 1;
            $("#letterarea").redactor("code.set", "");
            return;
        }

        // Match the letter with the recordID to avoid holding template contents in memory twice
        this.$.item = this.$.letters.find((letter) => Number(letter.recordID) === recordID);
        // Redactor workaround is appended to prevent edit/resize of img elements
        this.$.item.text = this.$.item.text.replace(/<img src=/g, `<img onclick="${this.redactorWorkaround}" src=`);
        $("#letterarea").redactor("code.set", this.$.item.text);
        if (this.$.letters[this.$.letters.length - 1].recordID === undefined) {
            this.$.letters.pop();
        }
    },
    startSaveProcess: function(scope, instance, form) {
        if (!form.$valid) {
            instance.stop(-1);
            return;
        }

        // Redactor workaround is removed to maintain consistency when later loading the template
        instance.options.factor  = .3;
        const escapedRedactorWorkaround = this.redactorWorkaround.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
        this.$.item.text = $("#letterarea").redactor("code.get");
        this.$.item.text = this.$.item.text.replace(
            new RegExp(`<img onclick="${escapedRedactorWorkaround}" src=`, "g"),
            "<img src="
        );
        this.$.item.date = (new Date()).getDateMySqlFormatted();

        if (typeof this.$.item.recordID !== "undefined" && this.$.item.schoolID !== "0") {
            this.AwardLetterTemplatesModelService.put(
                this.authServiceFactory.getAuth().schoolID,
                this.$.item,
                instance
            );
        } else {
            this.AwardLetterTemplatesModelService.post(
                this.authServiceFactory.getAuth().schoolID,
                this.$.item,
                instance
            );
        }
    },
    startDeleteProcess: function(scope, instance) {
        instance.options.factor  = .3;
        this.$.item.text = $("#letterarea").redactor("code.get");
        this.AwardLetterTemplatesModelService.purge(this.authServiceFactory.getAuth().schoolID, this.$.item, instance);
    },
    successSave: function(scope, instance, callback) {
        this.AwardLetterTemplatesModelService.resolveData(this.authServiceFactory.getAuth().schoolID).then(() => {
            this.$.letters = this.AwardLetterTemplatesModelService.get();
        });
        if (typeof callback !== "undefined") {
            callback();
        }
    },
    successDelete: function(scope, instance, callback) {
        this.$.item = {};
        $("#letterarea").redactor("code.set", "");
        this.AwardLetterTemplatesModelService.resolveData(this.authServiceFactory.getAuth().schoolID).then(() => {
            this.$.letters = this.AwardLetterTemplatesModelService.get();
        });

        if (typeof callback !== "undefined") {
            callback();
        }
    }
});
